import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpEventType} from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';

@Injectable()

export class RegulatoryItemEndpoint extends EndpointFactory {
  private readonly getRegulatoryItemTypesEndpointPath: string = "/api/ref/getRegulatoryItemTypes";
  private readonly getRegulatoryUpdateTypesEndpointPath: string = "/api/ref/getRegulatoryUpdateTypes";
  private readonly getDepartmentsEndpointPath: string = "/api/regulatoryItemService/getDepartments";
  private readonly getPSDepartmentsEndpointPath: string = "/api/regulatoryItemService/getPSDepartments";
  private readonly getAgenciesEndpointPath: string = "/api/regulatoryItemService/getAgencies";
  private readonly getLegislationsEndpointPath: string = "/api/regulatoryItemService/getLegislations";
  private readonly getAllRegulatoryItemsEndpointPath: string = "/api/regulatoryItemService/getAllRegulatoryItems";
  private readonly getRegulatoryItemEndpointPath: string = "/api/regulatoryItemService/getRegulatoryItem";
  private readonly getRegulatoryItemsByLegislationEndpointPath: string = "/api/regulatoryItemService/getRegulatoryItemsByLegislation";
  private readonly getRegulatoryItemsByAgencyEndpointPath: string = "/api/regulatoryItemService/getRegulatoryItemsByAgency";
  private readonly getPdfManageRegulatoryCountEndpointPath: string = "/api/regulatoryItemService/getPdfManageRegulatoryCount";
  private readonly submitRegulatoryItemEndpointPath: string = "/api/regulatoryItemService/submitRegulatoryItem";
  private readonly submitRegulatoryUpdateEndpointPath: string = "/api/regulatoryItemService/submitRegulatoryUpdate";
  private readonly createRegulatoryItemEndpointPath: string = "/api/regulatoryItemService/createRegulatoryItem";
  private readonly fileUploadEndpointPath: string = "/api/regulatoryItemService/fileUpload";
  private readonly helpFileUploadEndpointPath: string = "/api/regulatoryItemService/helpFileUpload";
  private readonly fileDownloadEndpointPath: string = "/api/regulatoryItemService/downloadFile";
  private readonly helpFileDownloadEndpointPath: string = "/api/regulatoryItemService/getFileUploadByName";
  private readonly importLegislationRegulatoryItemsEndpointPath: string = "/api/regulatoryItemService/importLegislationRegulatoryItems";
  private readonly importAgencyRegulatoryItemsEndpointPath: string = "/api/regulatoryItemService/importAgencyRegulatoryItems";


  get getRegulatoryItemTypesEndpointUrl() { return this.configurations.baseUrl + this.getRegulatoryItemTypesEndpointPath; }
  get getRegulatoryUpdateTypesEndpointUrl() { return this.configurations.baseUrl + this.getRegulatoryUpdateTypesEndpointPath; }
  get getDepartmentsEndpointUrl() { return this.configurations.baseUrl + this.getDepartmentsEndpointPath; }
  get getPSDepartmentsEndpointUrl() { return this.configurations.baseUrl + this.getPSDepartmentsEndpointPath; }
  get getAgenciesEndpointUrl() { return this.configurations.baseUrl + this.getAgenciesEndpointPath; }
  get getLegislationsEndpointUrl() { return this.configurations.baseUrl + this.getLegislationsEndpointPath; }
  get getAllRegulatoryItemsEndpointUrl() { return this.configurations.baseUrl + this.getAllRegulatoryItemsEndpointPath; }
  get getRegulatoryItemEndpointUrl() { return this.configurations.baseUrl + this.getRegulatoryItemEndpointPath; }
  get getRegulatoryItemsByLegislationEndpointUrl() { return this.configurations.baseUrl + this.getRegulatoryItemsByLegislationEndpointPath; }
  get getRegulatoryItemsByAgencyEndpointUrl() { return this.configurations.baseUrl + this.getRegulatoryItemsByAgencyEndpointPath; }
  get getPdfManageRegulatoryCountEndpointUrl() { return this.configurations.baseUrl + this.getPdfManageRegulatoryCountEndpointPath; }
  get submitRegulatoryItemEndpointUrl() { return this.configurations.baseUrl + this.submitRegulatoryItemEndpointPath; }
  get submitRegulatoryUpdateEndpointUrl() { return this.configurations.baseUrl + this.submitRegulatoryUpdateEndpointPath; }
  get createRegulatoryItemEndpointUrl() { return this.configurations.baseUrl + this.createRegulatoryItemEndpointPath; }
  get fileUploadEndpointUrl() { return this.configurations.baseUrl + this.fileUploadEndpointPath; }
  get helpFileUploadEndpointPathEndpointUrl() { return this.configurations.baseUrl + this.helpFileUploadEndpointPath; }
  get fileDownloadEndpointUrl() { return this.configurations.baseUrl + this.fileDownloadEndpointPath; }
  get helpFileDownloadEndpointUrl() { return this.configurations.baseUrl + this.helpFileDownloadEndpointPath; }
  get importLegislationRegulatoryItemsEndpointUrl() { return this.configurations.baseUrl + this.importLegislationRegulatoryItemsEndpointPath; }
  get importAgencyRegulatoryItemsEndpointUrl() { return this.configurations.baseUrl + this.importAgencyRegulatoryItemsEndpointPath; }

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);
  }

  getRegulatoryItemTypes<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getRegulatoryItemTypesEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getRegulatoryUpdateTypes<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getRegulatoryUpdateTypesEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getDepartments<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getDepartmentsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getPSDepartments<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getPSDepartmentsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAgencies<T>(departmentId?: string, userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getAgenciesEndpointUrl}/${departmentId}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getLegislations<T>(departmentId?: string, userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getLegislationsEndpointUrl}/${departmentId}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getRegulatoryItem<T>(regulatoryItemID?: string, userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getRegulatoryItemEndpointUrl}/${regulatoryItemID}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAllRegulatoryItems<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getAllRegulatoryItemsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getRegulatoryItemsByLegislation<T>(departmentId?: string, legislationID?: string, userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getRegulatoryItemsByLegislationEndpointUrl}/${departmentId}/${legislationID}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getRegulatoryItemsByAgency<T>(departmentId?: string, agencyID?: string, userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getRegulatoryItemsByAgencyEndpointUrl}/${departmentId}/${agencyID}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getPdfManageRegulatoryCount<T>(departmentId?: string, legislationId?: string, agencyId?: string): Observable<Blob> {
    let endpointUrl = `${this.getPdfManageRegulatoryCountEndpointUrl}/${departmentId}/${legislationId}/${agencyId}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

  getPdfManageRegulatoryCountUrl<T>(departmentId?: string, legislationId?: string, agencyId?: string): string {
    let endpointUrl = `${this.getPdfManageRegulatoryCountEndpointUrl}/${departmentId}/${legislationId}/${agencyId}`;
    return endpointUrl;
  }

  createRegulatoryItem<T>(): Observable<T> {
    let endpointUrl = `${this.createRegulatoryItemEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  submitRegulatoryItem<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.submitRegulatoryItemEndpointUrl}/`;
    //console.log(this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders()));
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }

  submitRegulatoryUpdate<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.submitRegulatoryUpdateEndpointUrl}/`;
    //console.log(this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders()));
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }


  async uploadExternalDocument(formData: any) {
    let endpointUrl = `${this.fileUploadEndpointUrl}/`;
    return await this.http.post(endpointUrl, formData, { reportProgress: true, observe: 'events' }).toPromise();
  }

  importLegislationRegulatoryItems<T>(formData: any): Observable<any>{
    let endpointUrl = `${this.importLegislationRegulatoryItemsEndpointUrl}/`;
    return this.http.post<any>(endpointUrl, formData);
  }

  importAgencyRegulatoryItems<T>(formData: any): Observable<any> {
    let endpointUrl = `${this.importAgencyRegulatoryItemsEndpointUrl}/`;
    return this.http.post<any>(endpointUrl, formData);
  }

  async uploadHelpFile(formData: any) {
    let endpointUrl = `${this.helpFileUploadEndpointPathEndpointUrl}/`;
    return await this.http.post(endpointUrl, formData, { reportProgress: true, observe: 'events' }).toPromise();
  }

  downloadFile(externalDocumentID: string, fileName: string): Observable<Blob> {
    let endpointUrl = `${this.fileDownloadEndpointUrl}/${externalDocumentID}/${fileName}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

  downloadHelpFile(fileName: string): string {
    let endpointUrl = `${this.helpFileDownloadEndpointUrl}/${fileName}`;
    return endpointUrl;
  }
}
